/**
 * free-gift-product-link.js
 *
 * Two cart-drawer fixes for personalised products (Custom Case / Custom Keychain).
 *
 * 1. Quick-add is wrong for them. The customer still has to upload artwork and
 *    pick a device, and their product pages carry no builder - the builder lives
 *    on dedicated pages (page.custom-case / page.custom-keychain templates). So
 *    the drawer's add-to-cart controls are replaced with a link to the builder.
 *
 * 2. They deliberately have no product image: the builder page uses the product's
 *    featured image as the base layer of its live mockup, so giving them one
 *    renders a phone case inside the phone. The drawer therefore falls back to a
 *    grey placeholder. Here we swap that placeholder for a mockup image, but only
 *    inside the drawer, and only until the customer's own artwork exists.
 *
 * Products needing no personalisation are left completely alone.
 */
(function () {
  var PLACEHOLDER_IMAGE =
    'https://cdn.shopify.com/s/files/1/0713/7830/5213/files/e8f59e63-f49a-4f00-927a-7ea5717f561d.jpg?v=1786746407';

  // Gift title pattern -> builder page that collects the artwork.
  var BUILDERS = [
    { match: /keychain/i, url: '/pages/custom-keychain' },
    { match: /custom/i, url: '/pages/custom-phone-case' }
  ];

  function titleOf(item, selector) {
    var el = item.querySelector(selector);
    return el ? el.textContent.trim() : '';
  }

  function builderFor(title) {
    for (var i = 0; i < BUILDERS.length; i++) {
      if (BUILDERS[i].match.test(title)) return BUILDERS[i].url;
    }
    return null;
  }

  /**
   * Replace the theme's placeholder SVG with the mockup image. Leaves any real
   * image alone, so a customer's uploaded artwork is never overwritten.
   */
  function fillPlaceholder(container, altText) {
    if (!container) return;
    if (container.querySelector('img')) return;

    var svg = container.querySelector('svg');
    if (!svg) return;

    var img = document.createElement('img');
    img.src = PLACEHOLDER_IMAGE;
    img.alt = altText;
    img.loading = 'lazy';
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = 'cover';
    svg.parentNode.replaceChild(img, svg);
  }

  function convertGift(item, url) {
    if (item.dataset.fgLinked === '1') return;

    var selectors = item.querySelector('.fg-device-selectors');
    if (selectors) selectors.style.display = 'none';

    var addBtn = item.querySelector('.free-gift-add-btn');
    if (addBtn) addBtn.style.display = 'none';

    var selectBtn = item.querySelector('.free-gift-select-btn');
    if (selectBtn) {
      var link = document.createElement('a');
      link.className = selectBtn.className;
      link.href = url;
      link.setAttribute('aria-label', 'Personalise ' + titleOf(item, '.upsell-name'));
      link.innerHTML = selectBtn.innerHTML;
      // Replacing the node drops the drawer's on:click binding along with it.
      selectBtn.parentNode.replaceChild(link, selectBtn);
    }

    item.dataset.fgLinked = '1';
  }

  function scan() {
    // Free gift picker entries.
    var gifts = document.querySelectorAll('.free-gift-item');
    for (var i = 0; i < gifts.length; i++) {
      var giftTitle = titleOf(gifts[i], '.upsell-name');
      if (!builderFor(giftTitle)) continue;
      fillPlaceholder(gifts[i].querySelector('.upsell-img'), giftTitle);
      convertGift(gifts[i], builderFor(giftTitle));
    }

    // Line items already in the bag that have no artwork yet.
    var lines = document.querySelectorAll('.cart-item-li');
    for (var j = 0; j < lines.length; j++) {
      var lineTitle = titleOf(lines[j], '.cart-item-title-compact');
      if (!builderFor(lineTitle)) continue;
      fillPlaceholder(lines[j].querySelector('.cart-item-image-link'), lineTitle);
    }
  }

  function start() {
    scan();
    // The drawer re-renders its contents after every cart update.
    var target = document.getElementById('cartDrawerWrapper') || document.body;
    new MutationObserver(scan).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
